import { Outlet } from 'react-router-dom';

export default function InterviewLayout() {
  return <Outlet />;
}
